import { render, staticRenderFns } from "./SystemFooter.vue?vue&type=template&id=cfbc0f58&scoped=true"
import script from "./SystemFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./SystemFooter.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbc0f58",
  null
  
)

export default component.exports